<script lang="ts" setup>
import { computed } from 'vue';
import LoadingPlaceholder from '../Loading/LoadingPlaceholder.vue';
import InputDecorator from './InputDecorator.vue';
import type { InputDecoratorProps } from './InputDecorator.vue';

const props = withDefaults(defineProps<{
    id: string;
    name?: string;
    value: string;
    disabled?: boolean;
    loading?: boolean;
    placeholder?: string;
    rows?: number;
    cols?: number;
    maxlength?: number;
    fullWidth?: boolean;
} & InputDecoratorProps >(), {
    errors: () => [],
    rows: 5,
    cols: 50,
    maxlength: 500,
    fullWidth: false
});

const emit = defineEmits(['update', 'blur']);

const computedValue = computed({
    get() {
        return props.value;
    },
    set(value) {
        emit('update', value);
    }
});
</script>

<template>
    <InputDecorator :for-id="id" :label="label" :help="help" :errors="errors" :required="required">
        <textarea
            :class="['form-control', {'full-width': fullWidth}]"
            :id="id"
            :name="name"
            :placeholder="placeholder"
            :rows="rows"
            :cols="cols"
            :maxlength="maxlength"
            :disabled="disabled"
            v-model="computedValue"
            @blur="emit('blur')"
            v-if="!loading"
        ></textarea>
        <LoadingPlaceholder height="147px" width="400px" v-else/>
    </InputDecorator>
</template>

<style lang="scss" scoped>
.full-width {
    width: 100%;
}
</style>